import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from './locale.service';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  public transform(value: string | number | Date, format = 'mediumDate', timezone?: string): string {
    if (value == null) {
      return '';
    }
    const locale = this.localeService.currentLanguage === 'hr' ? 'hr-HR' : 'en-US';
    return formatDate(value, format, locale, timezone);
  }
}
